export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const GRANT_PERMISSIONS = 'GRANT_PERMISSIONS';
export const REVOKE_PERMISSIONS = 'REVOKE_PERMISSIONS';



// WEBPACK FOOTER //
// ./src/actions/permissionsTypes.js